import type { CountryLanguages } from '~/types/countryLanguages';
import type { StoryblokConfigSlug } from '~/types/storyblokConfigSlug';
import { findSectionConfigById } from '~/utils/findSectionConfigById';
import { parseLocaleFromPath } from '~/utils/parseLocaleFromPath';
import { resolveSectionPath } from '~/utils/resolveSectionPath';

export function isValidAcademyTrainingPath(
    registry: StoryblokConfigSlug[] | null | undefined,
    path: string,
    countryLanguages: CountryLanguages
): boolean {
    const locale = parseLocaleFromPath(path);
    if (!locale?.country || !locale.language) return false;

    const segments = path.split('/').filter(Boolean);
    const trainingSegmentIndex = segments.length - 2;
    const trainingId = segments.at(-1);

    if (segments[trainingSegmentIndex] !== 'training' || !trainingId || !/^\d+$/.test(trainingId)) return false;

    const requestedSectionPath = segments.slice(1, trainingSegmentIndex).join('/');
    const academyConfig = findSectionConfigById(registry, locale.country, 'academy');
    const academyPath = academyConfig ? resolveSectionPath(academyConfig, locale.language, countryLanguages) : null;

    return academyPath !== null && requestedSectionPath === academyPath;
}
